import { useState, } from 'react';
import { Col, Form, Row, Button, Card } from 'react-bootstrap';
import Reload from '../../../components/reload/reload';

function Password(props) {
    const { serial, socket, loading, setLoading } = props;

    const [pass, setPass] = useState({
        password1: '',
        password2: ''
    })

    const handleConfirm = async () => {
        const password1 = pass.password1;
        const password2 = pass.password2;

        if (password1 === password2) {
            if (isPasswordSecure(password1)) {
                handleSetPassword(password1);
            } else {
                alert("A senha deve conter no minimo 4 caracteres!");
            }
        } else {
            alert("As senhas não são iguais");
        }
    }

    function isPasswordSecure(password) {
        if (password.length < 4) {
            return false;
        }
        return true;
    }

    const handleSetPassword = (password) => {
        if (!serial) {
            return
        }
        setLoading(true)
        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                content: {
                    command: 'web_browser',
                    parameters: {
                        value: 'set_change_password',
                        page: 'set_password',
                        password: password
                    }
                },
            })
        );
        localStorage.setItem('access_key', btoa(JSON.stringify(password)));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleConfirm();
        }
    };

    return (
        <Card className="p-3" style={{ height: "100vh", background: "#0C392E" }}>
            <h1 style={{ textAlign: "center", color: "#f4f4f4" }}>Loc Solution | Motomco</h1>
            {loading && <Reload />}
            <Form
                className='p-3 text-center'
                style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "28vh",
                    border: "solid 1px #198754",
                    borderRadius: "1rem"
                }}
            >
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword0">
                    <Col>
                        <Form.Control
                            value={pass.password1}
                            type="password"
                            placeholder="Nova Senha"
                            onKeyDown={handleKeyDown}
                            onChange={event => {
                                setPass({ ...pass, password1: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword1">
                    <Col>
                        <Form.Control
                            value={pass.password2}
                            type="password"
                            placeholder="Confirmar Nova Senha"
                            onKeyDown={handleKeyDown}
                            onChange={event => {
                                setPass({ ...pass, password2: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>
                <Button
                    className='w-100'
                    variant="success"
                    onClick={() => {
                        handleConfirm()
                    }}>
                    Salvar
                </Button>

            </Form>
        </Card>
    );
}

export default Password;
